import { END_POINT } from "../../constants/api.constants";

const {
  LOGIN,
  VERIFY_CUSTOMER_EMAIL,
  RESEND_CUSTOMER_VERIFICATION_MAIL,
  FORGOT_PASSWORD,
} = END_POINT;

export const loginAPI = async (payload) => {
  return await fetch(LOGIN, {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      return {
        status: data.status,
        message: data.message,
        data: data.data,
      };
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const verifyCustomerEmailAPI = async (payload) => {
  return await fetch(VERIFY_CUSTOMER_EMAIL, {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      return {
        status: data.status,
        message: data.message,
        data: data.data,
      };
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const resendCustomerEmailAPI = async (payload) => {
  return await fetch(RESEND_CUSTOMER_VERIFICATION_MAIL, {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      return {
        status: data.status,
        message: data.message,
        data: data.data,
      };
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const forgotPasswordAPI = async (username) => {
  return await fetch(FORGOT_PASSWORD, {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify({ username }),
  })
    .then((res) => res.json())
    .then((data) => {
      return {
        status: data.status,
        message: data.message,
        data: data.data,
      };
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};
